module.exports = __webpack_public_path__ + "img/Competiton2.48cb8945.png";